import { render, staticRenderFns } from "./salesStore.vue?vue&type=template&id=5512fa7c&scoped=true&"
import script from "./salesStore.vue?vue&type=script&lang=js&"
export * from "./salesStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512fa7c",
  null
  
)

export default component.exports